import { useNavigate } from 'react-router';
import { useAuth } from '@/hooks/useAuth';

function useLogout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout({
      callback: () => {
        navigate('/login');
      },
    });
  };

  return handleLogout;
}

export { useLogout };
